import { formatDocumentVersionRef, formatSegmentRef } from "../../../../shared/references/contentReferences";
import type { ThreadSubject } from "../threadIntent";

export type SelectionError = "limit" | "overlap";
export const MAXIMUM_ENTRIES = 200;

export function entryReference(entry: ThreadSubject): string {
  return entry.segmentPath === undefined ? formatDocumentVersionRef(entry.document) : formatSegmentRef(entry.document, entry.segmentPath);
}

export function selectionError(entries: readonly ThreadSubject[], candidate: ThreadSubject): SelectionError | null {
  if (entries.length >= MAXIMUM_ENTRIES) return "limit";
  const path = candidate.segmentPath ?? "";
  const overlaps = entries.some((entry) => {
    if (formatDocumentVersionRef(entry.document) !== formatDocumentVersionRef(candidate.document)) return false;
    const prior = entry.segmentPath ?? "";
    return prior === "" || path === "" || prior === path || prior.startsWith(`${path}/`) || path.startsWith(`${prior}/`);
  });
  return overlaps ? "overlap" : null;
}

export function addEntry(entries: readonly ThreadSubject[], candidate: ThreadSubject): readonly ThreadSubject[] {
  return selectionError(entries, candidate) === null ? [...entries, candidate] : entries;
}

/** Omit selection for one subject so existing start requests keep their shape. */
export function entryBindings(entries: readonly ThreadSubject[]): { subject: string | null; selection?: string[] } {
  const references = entries.map(entryReference);
  return { subject: references[0] ?? null, ...(references.length > 1 ? { selection: references } : {}) };
}
